export default __webpack_public_path__ + "static/media/899.23dc8bd0.png";